import DayHoraire from './DayHoraire.view';

export default DayHoraire;
